<template>
  <v-dialog v-model="localDialog" persistent max-width="650px">
    <v-card>
      <ModelTitle title="Materials Covered (Assign Template)" @close="close" />

      <v-card-text v-if="selectedClassRoom">
        <div class="mb-2">
          <div>
            Class: <b>{{ selectedClassRoom.Class ? selectedClassRoom.Class.name : "N/A" }}</b>
          </div>
          <div>
            Room: <b>{{ selectedClassRoom.name || "N/A" }}</b>
          </div>
        </div>

        <v-select
          v-model="selectedYear"
          :items="years"
          item-text="name"
          return-object
          outlined
          dense
          label="Select Year"
          @change="loadTerms"
        />

        <v-select
          v-model="selectedTerm"
          :items="terms"
          item-text="name"
          return-object
          outlined
          dense
          label="Select Term"
          :disabled="!selectedYear"
        />

        <v-select
          v-model="selectedTemplate"
          :items="templates"
          item-text="name"
          return-object
          outlined
          dense
          label="Select Template"
        />

        <div class="caption grey--text mt-2" v-if="selectedTemplate">
          Questions: {{ selectedTemplate.fields ? selectedTemplate.fields.length : 0 }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text color="secondary" @click="close">Close</v-btn>
        <v-btn color="primary" dark :loading="saving" @click="save" :disabled="!canSave">
          Assign
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import termMaterialsService from "@/modules/TermMaterials/service";
import yearService from "@/modules/ReportCard/Year/service";
import termService from "@/modules/ReportCard/Terms/service";

export default {
  name: "AssignTermMaterialTemplate",
  props: {
    dialog: { default: false },
    selectedClassRoom: { type: Object },
  },
  data() {
    return {
      localDialog: false,
      saving: false,
      years: [],
      terms: [],
      templates: [],
      selectedYear: null,
      selectedTerm: null,
      selectedTemplate: null,
    };
  },
  watch: {
    dialog(val) {
      this.localDialog = val;
      if (val) this.init();
    },
  },
  computed: {
    canSave() {
      return !!(this.selectedClassRoom && this.selectedTerm && this.selectedTemplate);
    },
  },
  methods: {
    async init() {
      this.selectedYear = null;
      this.selectedTerm = null;
      this.selectedTemplate = null;
      this.terms = [];

      const yr = await yearService.getAll({
        filteredClasses: [this.selectedClassRoom.ClassId],
      });
      this.years = (yr && yr.data) ? yr.data : [];

      const t = await termMaterialsService.getTemplates();
      this.templates = (t && t.data && t.data) ? t.data : [];
    },

    async loadTerms() {
      this.selectedTerm = null;
      this.terms = [];
      if (!this.selectedYear) return;

      const res = await termService.getAll({ YearId: this.selectedYear.id });
      this.terms = (res && res.data) ? res.data : [];
    },

    close() {
      this.$emit("close");
    },

    async save() {
      if (!this.canSave) return;

      this.saving = true;
      try {
        await termMaterialsService.assignTemplate({
          ClassRoomId: this.selectedClassRoom.id,
          TermId: this.selectedTerm.id,
          TermMaterialTemplateId: this.selectedTemplate.id,
        });

        this.$swal.mixin({ toast: true, position: "top-end", showConfirmButton: false, timer: 3000 })
          .fire({ icon: "success", title: "Assigned" });

        this.$emit("saved");
        this.close();
      } catch (e) {
        this.$swal.mixin({ toast: true, position: "top-end", showConfirmButton: false, timer: 3000 })
          .fire({ icon: "error", title: (e && e.data && e.data.message) ? e.data.message : "Assign failed" });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>